// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"arcade-embed_wrapper__jpjDP","title":"arcade-embed_title__gLgH_","iframeContainer":"arcade-embed_iframeContainer__wbh9y","iframe":"arcade-embed_iframe__vfUIw"};